import React from 'react';
import { useCart } from '../context/CartContext';
import './Products.css';

function Gaming() {
  const { addToCart } = useCart();

  const gamingProducts = [
    {
      id: 'game1',
      name: 'Gaming Headset Pro',
      price: 89,
      originalPrice: 129,
      image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Gaming',
      description: '7.1 surround sound gaming headset with mic'
    },
    {
      id: 'game2',
      name: 'Gaming Mouse',
      price: 59,
      originalPrice: 79,
      image: 'https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Gaming',
      description: 'High-DPI gaming mouse with RGB lighting'
    },
    {
      id: 'game3',
      name: 'Gaming Keyboard',
      price: 99,
      originalPrice: 149,
      image: 'https://images.unsplash.com/photo-1541140532154-b024d705b90a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Gaming',
      description: 'Mechanical gaming keyboard with backlight'
    },
    {
      id: 'game4',
      name: 'Gaming Controller',
      price: 49,
      originalPrice: 69,
      image: 'https://images.unsplash.com/photo-1486401899868-0e435ed85128?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Gaming',
      description: 'Wireless gaming controller for PC/console'
    },
    {
      id: 'game5',
      name: 'Gaming Chair',
      price: 199,
      originalPrice: 299,
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Gaming',
      description: 'Ergonomic gaming chair with lumbar support'
    },
    {
      id: 'game6',
      name: 'Gaming Monitor',
      price: 299,
      originalPrice: 399,
      image: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Gaming',
      description: '27-inch 144Hz gaming monitor'
    },
    {
      id: 'game7',
      name: 'Gaming Mouse Pad',
      price: 19,
      originalPrice: 29,
      image: 'https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Gaming',
      description: 'Large RGB gaming mouse pad'
    },
    {
      id: 'game8',
      name: 'Gaming Microphone',
      price: 79,
      originalPrice: 99,
      image: 'https://images.unsplash.com/photo-1598488035139-bdaa7543d6f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
      category: 'Gaming',
      description: 'USB condenser microphone for streaming'
    }
  ];

  const handleAddToCart = (product) => {
    addToCart(product);
  };

  return (
    <div className="products-page">
      <div className="container">
        <div className="page-header">
          <h1>Gaming</h1>
          <p>Games and gaming accessories for every gamer</p>
        </div>
        
        <div className="product-grid">
          {gamingProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                <img src={product.image} alt={product.name} />
              </div>
              <div className="product-info">
                <h4>{product.name}</h4>
                <p className="product-description">{product.description}</p>
                <div className="price">
                  <span className="current-price">${product.price}</span>
                  <span className="original-price">${product.originalPrice}</span>
                  <span className="discount">
                    {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% off
                  </span>
                </div>
                <button 
                  className="add-to-cart"
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Gaming; 